module.exports = __webpack_public_path__ + "static/media/image-campaign-donate-house.5d684734.png";